import { AxiosResponse } from 'axios';

export const processResponse = <T extends {}>(response: AxiosResponse<T>): Promise<T> =>
  new Promise((fulfill, reject) => {
    if (response.status >= 200 && response.status < 300) {
      fulfill(response.data);
    } else {
      reject(new Error(response.statusText));
    }
  });



// WEBPACK FOOTER //
// ./src/util/service-util.ts